"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TokenSearchContext_1 = __importDefault(require("./TokenSearchContext"));
var TokenSearchServiceContext_1 = __importDefault(require("./TokenSearchServiceContext"));
exports.default = (function (Component) {
    return function tokenSearchWrapper(props) {
        return (react_1.default.createElement(TokenSearchConsumer, null, function (tokenSearchService, tokenSearchScope) {
            return (react_1.default.createElement(Component, __assign({}, props, { startingSearchTerm: tokenSearchScope ? "".concat(tokenSearchScope.childPropertyLabel || tokenSearchScope.label, ".") : undefined, searchTokens: tokenSearchService.createSearchFn(tokenSearchScope) })));
        }));
    };
});
var TokenSearchConsumer = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(TokenSearchServiceContext_1.default.Consumer, null, function (tokenSearchService) {
        if (!tokenSearchService) {
            throw new Error("withTokenSearchContext must be used within a TokenSearchServiceContext.Provider");
        }
        return (react_1.default.createElement(TokenSearchContext_1.default.Consumer, null, function (tokenSearchScope) {
            return children(tokenSearchService, tokenSearchScope);
        }));
    }));
};
